$.fn.inlineEdit = function (options) {
  var defaults = {
    confirm: "<button  class='btn btn-primary btn-sm '> Save </button>",
    cancel: "<button  class='btn btn-primary btn-sm '>Cancel</button >",
    separator: " ",
    reverse: false,
    hideOriginalAction: true,
    bindsOnEvent: "click",
    confirmCallback: function () {
      return true;
    },
    cancelCallback: function () {
      return true;
    }
  };

  var original_action;
  var timeout_id;
  var all_actions = $(this);
  var options = $.extend(defaults, options);
  var block_class = "inline-edit-block";
  var confirm_class = "inline-edit-confirm";
  var inputClass = "inline-edit-control";
  var cancel_class = "inline-edit-cancel";
  var action_class = "inline-edit-action";

  options.confirm = "<span class='" + action_class + " " + confirm_class + "'>" + options.confirm + "</span>";
  options.cancel = "<span class='" + action_class + " " + cancel_class + "'>" + options.cancel + "</span>";

  var action_set = options.reverse === false
    ? options.confirm + options.separator + options.cancel
    : options.cancel + options.separator + options.confirm;

  $(this).on(options.bindsOnEvent, function (e) {
    original_action = $(this);
    var name = $(this).attr('data-edit-inline'),
      $eventEl = $(name)
      ;

    all_actions.show();
    $("span." + block_class).hide();

    if ($eventEl.length) {
      original_action.hide();
      $eventEl.removeAttr('readonly').addClass('form-control form-control-sm').removeClass('form-control-plaintext');
    }

    var active_action_set = $("span." + block_class, $(this).parent());

    if (active_action_set.length > 0) {
      active_action_set.show();
    } else {
      $(this).after("<span class='" + block_class + "'>" + action_set + "</span>");
    }

    e.preventDefault();
    return false;
  });

  $(this).parent().delegate("input." + inputClass, "keypress", function () {
    var minWidth = 200;
    var newWidth = $(this).val().length * 8;
    console.log(newWidth, minWidth);

    newWidth = newWidth > minWidth ? newWidth : minWidth;
    $(this).css("width", newWidth);
  });

  $(this).parent().delegate("span." + action_class, "click", function () {

    $(this).parent().hide();
    original_action.show();
    var name = original_action.attr('data-edit-inline'),
      $eventEl = $(name)
      ;
    $eventEl.attr('readonly', 'readonly').addClass('form-control-plaintext').removeClass('form-control form-control-sm');

    var args = new Array();
    args[0] = original_action;

    if ($(this).hasClass(confirm_class)) {

      options.confirmCallback.apply(this, args);
    } else {
      options.cancelCallback.apply(this, args);
    }
    return false;
  });
};